const SearchComponent: React.FC<{
  searchQuery: string;
  statusQuery: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onClearFilters: () => void;
}> = ({
  searchQuery,
  statusQuery,
  onSearchChange,
  onStatusChange,
  onClearFilters,
}) => {
  return (
    <div className="mb-4 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      <div className="flex flex-col sm:flex-row gap-2 flex-1">
        <div className="relative flex-1 max-w-md">
          <input
            type="text"
            placeholder="Search by reference..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg "
          />
        </div>
        <div className="relative flex-1 max-w-md">
          <input
            type="text"
            placeholder="Status"
            value={statusQuery}
            onChange={(e) => onStatusChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg "
          />
        </div>
        {(searchQuery || statusQuery) && (
          <button
            onClick={onClearFilters}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
};
export default SearchComponent;
